import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    total: 0,
    loading: false,
    searching: false,
    submitting: false,
    searchParams: {
        whiteIP: "",
        operatorID: "",
        page: 1,
        count: 30,
        refresh: false,
        ...getUserConfig("whiteIP")
    }
}

const whiteIP = (state = initialState, action) => {
    switch (action.type) {
        case 'WHITE_IP':
            return {
                ...state,
                ...action.payload
            }
        case 'WHITE_IP_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams, ...getUserConfig("whiteIP")
                }
            }
        default:
            return {...state};
    }
}

export default whiteIP
